export default __webpack_public_path__ + "static/media/placeholder_business05-en-mobile.d2a97e7b.png";